import React from 'react';

const DisplayDate: React.FC<{ date: Date }> = ({ date }) => (
  <>{date ? new Date(date).toLocaleString() : ""}</>
)

export default DisplayDate;